import './checkbox.scss';
import React, {useEffect, useState} from 'react';
import {Icons} from '../../icons/icons';
import {SvgIcon} from '../../icons/svgIcon';
import classNames from 'clsx';
import {useTranslation} from 'react-i18next';

type FlexDirection = 'row' | 'row-reverse' | 'column' | 'column-reverse';
type CheckBoxJustifyContent = 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly';

type InputProps = {
    value: boolean;
    onChange?: (value: boolean) => void;
    mayEdit: boolean;
    labelKey: string;
    checkBoxFlexDirection?: FlexDirection;
    checkJustifyContent?: CheckBoxJustifyContent;
    className?: string;
    isRawHtml?: boolean;
};

export const Checkbox = React.memo(
    ({
         labelKey,
         mayEdit,
         onChange,
         value,
         checkBoxFlexDirection = 'row',
         checkJustifyContent = 'flex-start',
         className,
         isRawHtml = false,
     }: InputProps) => {
        const [localValue, setLocalValue] = useState<boolean>(value);
        const {t} = useTranslation();

        useEffect(() => {
            setLocalValue(value);
        }, [value]);

        const onClick = () => {
            if (mayEdit) {
                onChange?.(!localValue);
                setLocalValue(!localValue);
            }
        };

        return (
            <div
                className={classNames('checkbox', className)}
                style={
                    {
                        '--flex-direction': checkBoxFlexDirection,
                        '--justify-content': checkJustifyContent,
                    } as React.CSSProperties
                }
            >
                {mayEdit && <input
                    type="checkbox"
                    id={'chk-' + labelKey}
                    name={t(labelKey || 'checkbox')}
                    checked={localValue}
                    onChange={onClick}/>}
                {!mayEdit && localValue && <SvgIcon icon={Icons.CONFIRM} className={classNames()}/>}
                {!mayEdit && !localValue && <div>-</div>}
                {labelKey && isRawHtml &&
                    <label htmlFor={'chk-' + labelKey} dangerouslySetInnerHTML={{__html: `${labelKey}`}}/>}
                {labelKey && !isRawHtml && <label htmlFor={'chk-' + labelKey}>{t(labelKey)}</label>}
            </div>
        );
    },
);
